import type { Row } from '@tanstack/react-table'
import { flexRender } from '@tanstack/react-table'
import * as React from 'react'

import * as Sortable from '../../sortable'
import { Table } from '../../table/Table'
import { DataTableDataCell } from '../DataTableDataCell'

export type DataTableDraggableRowProps = React.ComponentProps<
  typeof Table.Row
> & {
  row: Row<Record<string, unknown>>
  idColumn?: string
}

export const DragAndDropTableRow = ({
  row,
  idColumn = 'id'
}: DataTableDraggableRowProps) => {
  const rowId = row.original[idColumn] as string | number
  return (
    <Sortable.Item id={rowId} asChild>
      <Table.Row>
        {row.getVisibleCells().map((cell, i) => {
          if (i === 0) {
            return (
              <Table.Cell key={cell.id}>
                <Sortable.Handle targetId={rowId} className="inline-block" />
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </Table.Cell>
            )
          }
          return <DataTableDataCell key={cell.id} cell={cell} />
        })}
      </Table.Row>
    </Sortable.Item>
  )
}
